<div class="alert alert-warning" role="alert" *ngIf="violations.length > 0">
  <p class="mb-2" *ngFor="let row of violations">
    {{ row.name }} is {{ row.age }}. This event type requires participants to be
    {{ (row.code === AgeRestrictionCode.minAge) ? 'at least' : 'at most' }}
    {{ row.limit }}{{ atEventStart ? " at the event's start" : '' }}.
  </p>
  <div class="form-check">
    <input class="form-check-input" type="checkbox"
           [id]="inputId"
           [name]="inputId"
           [disabled]="disabled"
           [class.disabled]="disabled"
           [ngModel]="acknowledged"
           (ngModelChange)="setAcknowledged($event)">
    <label class="form-check-label" [for]="inputId">
      Bypass the age restriction for the {{ (participantCount() === 1) ? 'participant' : 'participants' }}
      listed above. This will be recorded in the activity log.
    </label>
  </div>
</div>
